import React from 'react';
import TextAreaInput from '../../components/TextAreaInput';

type FilterProps = {
    blockReason: string,
    setBlockReason: (arg0: string) => void,
    setBlock: () => void,
}

export default function BlockClientModal({
  blockReason,
  setBlockReason,
  setBlock,
}: FilterProps) {
  return (
    <div className="modal fade" id="blockModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Bloqueio permanente</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            <p className="mb-4 fw-bold">Essa é uma ação permanente. Tem certeza?</p>
            <TextAreaInput
              id=""
              label="Motivo do bloqueio"
              readOnly={false}
              helper="O porque esse usuário está sendo bloqueado permanentemente"
              error=""
              value={blockReason}
              onChange={(data) => setBlockReason(data)}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => setBlock()}>Bloquear</button>
          </div>
        </div>
      </div>
    </div>
  );
}
